/* unplugin-vue-components disabled */import { render } from "./AuthorIconGroupPicto.vue?vue&type=template&id=4a1628f2&scoped=true&ts=true"
import script from "./AuthorIconGroupPicto.vue?vue&type=script&lang=ts"
export * from "./AuthorIconGroupPicto.vue?vue&type=script&lang=ts"

import "./AuthorIconGroupPicto.vue?vue&type=style&index=0&id=4a1628f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1628f2"]])

export default __exports__